import React from "react";

export default class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: undefined };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // TODO: send to your server / Sentry
    console.error("[AppErrorBoundary]", error, info);
  }

  handleReload = () => {
    this.setState({ hasError: false, error: undefined });
    // Optionally: window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen grid place-items-center p-6">
          <div className="max-w-lg w-full rounded-2xl shadow p-6">
            <h1 className="text-2xl font-semibold">Something went wrong</h1>
            <p className="mt-2 text-sm opacity-80">
              {process.env.NODE_ENV === "development"
                ? this.state.error?.message
                : "Please try again."}
            </p>
            <div className="mt-4 flex gap-2">
              <button
                onClick={this.handleReload}
                className="px-4 py-2 rounded-xl border"
              >
                Try again
              </button>
              <button
                onClick={() => window.location.reload()}
                className="px-4 py-2 rounded-xl border"
              >
                Reload page
              </button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
